var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-end mt-1"},[_c('VinStatChange',{attrs:{"change-class":_vm.computedChangeClass,"direction":_vm.computedDirection,"change":_vm.computedDelta}}),_c('p',{staticClass:"text-copy text-sm tracking-relaxed leading-none"},[_vm._v(" "+_vm._s(_vm.computedText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }